import { Select } from 'antd';


const PeriodSelect = ({ value = [], onChange, disabled = false }) => {

    const handleChange = (newTags) => {
        onChange?.(newTags);
    };

    return (
       <Select
          showSearch
          disabled={disabled}
          style={{ minWidth: 200, flex: 1 }}
          placeholder=""
          optionFilterProp="label"
          options={[
              { label: '', value: null },
              { label: 'Vsako leto', value: 'yearly' },
              { label: 'Vsak mesec', value: 'monthly' },
              { label: 'Vsak teden', value: 'weekly' },
              { label: 'Vsak dan', value: 'daily' },
          ]}
          value={value}
          onChange={handleChange}
        />
    );
}

export default PeriodSelect;
